import {ChangeDetectorRef, Component, forwardRef, OnInit} from "@angular/core";
import {AbstractVisbosControl} from "../../core/visbos-core/ui/forms/abstract-visbos-control";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Mission} from "../model/mission.type";
import {appInjector} from "../../index";
import {DatePipe} from "@angular/common";
import {KeyboardOptions} from "virtual-keyboard";
import {GERMAN_LAYOUT} from "../../core/visbos-core/ui/directives/on-screen-keyboard.directive";

@Component({
  selector: 'vb-mission-form',
  templateUrl: './mission-form.component.html',
  styleUrls: ['./mission-form.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => MissionFormComponent)}]
})
export class MissionFormComponent extends AbstractVisbosControl<Mission, FormGroup> implements OnInit {

  kbOptions: KeyboardOptions = {
    type: 'input',
    layout: 'custom',
    customLayout: GERMAN_LAYOUT
  };

  constructor(fb?: FormBuilder, cd?: ChangeDetectorRef) {
    super(fb, cd, null);
  }

  buildControlContent(): FormGroup {
    return MissionFormComponent.initControl(this.fb);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  public static initControl(fb: FormBuilder = null): FormGroup {
    fb = fb ? fb : appInjector().get(FormBuilder);

    return fb.group({
      cuid: [null],
      mission_number: [null, Validators.required],
      mission_date: [null, Validators.required],
    });

  }

  setDefaultValues(item?: Mission): { [controlKey: string]: any } | any {
    return {
      cuid: this.setValue(item, 'cuid', AbstractVisbosControl.cuid()),
      mission_number: this.setValue(item, 'mission_number'),
      mission_date: this.setValue(item, 'mission_date', new DatePipe('de').transform(new Date(), 'yyyy-MM-dd')),
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/mission/mission-form/mission-form.component.ts